import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { RecommendedCreditScoreDesktop } from './components/Desktop';
import { RecommendedCreditScoreMobile } from './components/Mobile';
export function RecommendedCreditScore() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Box display={{
      xs: "none",
      md: "block"
    }}><RecommendedCreditScoreDesktop /></Box>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<Box display={{
        xs: "block",
        md: "none"
      }}><RecommendedCreditScoreMobile /></Box></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}